// Import de toastify-js et son CSS
import Toastify from 'toastify-js';
import 'toastify-js/src/toastify.css';

// Fonction pour tronquer un message à 100 caractères avec "..."
function truncateMessage(message: string, maxLength: number = 100): string {
  if (message.length <= maxLength) {
    return message;
  }
  return message.substring(0, maxLength - 3) + '...';
}

// Utilitaire pour afficher les toasts
export function showToast(message: string, type: 'success' | 'error' | 'warning' | 'info' = 'info') {
  try {
    // Tronquer le message à 100 caractères si nécessaire
    const truncatedMessage = truncateMessage(message, 100);
    
    // Vérifier que Toastify est disponible
    if (typeof Toastify === 'undefined' || !Toastify) {
      console.warn('[Toast] Toastify n\'est pas disponible, utilisation du fallback console');
      console.log(`[${type.toUpperCase()}] ${truncatedMessage}`);
      return;
    }

    let backgroundColor = '';
    
    switch (type) {
      case 'success':
        backgroundColor = '#28a745';
        break;
      case 'error':
        backgroundColor = '#dc3545';
        break;
      case 'warning':
        backgroundColor = '#ffc107';
        break;
      case 'info':
        backgroundColor = '#17a2b8';
        break;
    }
    
    const toast = Toastify({
      text: truncatedMessage,
      duration: 4000,
      close: true,
      gravity: 'top',
      position: 'right',
      stopOnFocus: true,
      style: {
        borderRadius: '20px',
        background: backgroundColor,
        color: '#fff',
        padding: '12px 20px',
        fontSize: '14px',
        fontWeight: '500',
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
      },
    });

    if (toast && typeof toast.showToast === 'function') {
      toast.showToast();
    } else {
      console.warn('[Toast] La méthode showToast n\'est pas disponible');
      console.log(`[${type.toUpperCase()}] ${truncatedMessage}`);
    }
  } catch (error) {
    // Fallback vers console si toastify n'est pas disponible
    console.error(`[Toast Error]`, error);
    const truncatedMessage = truncateMessage(message, 100);
    console.log(`[${type.toUpperCase()}] ${truncatedMessage}`);
  }
}

